var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { DEFAULT_QUALITY, LOGGER_NAME } from './common/constants';
import { createConnection, fetchConnectionConfiguration } from './connection/util/connection_functions';
import { RequestModule } from './core/RequestModule';
import { SubscriptionModule } from './core/SubscriptionModule';
import { NullLogger } from './logger';
var Mdg2Client = (function () {
    function Mdg2Client(connection, options) {
        if (options === void 0) { options = {}; }
        var _a, _b;
        this.flagPermissionDenied = (_a = options.flagPermissionDenied) !== null && _a !== void 0 ? _a : false;
        this.shouldRestartSubscriptions = (_b = options.shouldRestartSubscriptions) !== null && _b !== void 0 ? _b : true;
        this.logger = connection ? connection.options.logger : new NullLogger(LOGGER_NAME);
        this.requestModule = new RequestModule(this);
        this.subscriptionModule = new SubscriptionModule(this, this.requestModule);
        if (connection) {
            this.connection = connection;
            this.connection.shouldRestartSubscriptions = this.shouldRestartSubscriptions;
            this.connection.restartSubscriptions = this.subscriptionModule.restartSubscriptions.bind(this.subscriptionModule);
            this.connection.onCleanupRequests = this.requestModule.clearPendingRequests.bind(this.requestModule);
            this.connection.onCleanupSubscriptions = this.subscriptionModule.clearPendingSubscriptions.bind(this.subscriptionModule);
        }
    }
    Mdg2Client.prototype.connect = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.connection) {
                            throw new Error('no connection defined. please set a connection before trying to connect.');
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.connection.open()];
                    case 2:
                        _a.sent();
                        return [3, 4];
                    case 3:
                        error_1 = _a.sent();
                        return [2, Promise.reject(error_1)];
                    case 4:
                        this.requestModule.onConnection();
                        return [2, Promise.resolve()];
                }
            });
        });
    };
    Mdg2Client.prototype.disconnect = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.connection) {
                            throw new Error('no connection defined. please set a connection before trying to disconnect.');
                        }
                        return [4, this.connection.close()];
                    case 1:
                        _a.sent();
                        this.requestModule.reset();
                        return [2];
                }
            });
        });
    };
    Mdg2Client.prototype.request = function (msg) {
        return this.requestModule.request(msg);
    };
    Mdg2Client.prototype.restartSubscriptions = function () {
        this.subscriptionModule.restartSubscriptions();
    };
    Mdg2Client.prototype.requestWithQuality = function (msg, quality) {
        if (quality === void 0) { quality = DEFAULT_QUALITY; }
        return this.requestModule.requestWithQuality(msg, quality);
    };
    Mdg2Client.prototype.requestEndpoint = function (method, path, data, options, timeOutInMs) {
        return this.requestModule.requestEndpoint(method, path, data, options, timeOutInMs);
    };
    Mdg2Client.prototype.requestProxyEndpoint = function (method, path, body, options, timeOutInMs) {
        return this.requestModule.requestProxyEndpoint(method, path, body, options, timeOutInMs);
    };
    Mdg2Client.prototype.requestAuthenticationToken = function (lifetimeSeconds, idUser, idApplication) {
        return this.requestModule.requestAuthenticationToken(lifetimeSeconds, idUser, idApplication);
    };
    Mdg2Client.prototype.requestAuthenticationTokenForCookieTokenAuthentication = function (lifetimeSeconds, idUser, idApplication) {
        return this.requestModule.requestAuthenticationTokenFactorsForCookieAuthentication(lifetimeSeconds, idUser, idApplication);
    };
    Mdg2Client.prototype.observeEndpoint = function (method, path, data, options) {
        return this.subscriptionModule.observeEndpoint(method, path, data, options);
    };
    Mdg2Client.prototype.unobserveEndpoint = function (idJob) {
        return this.subscriptionModule.unobserveEndpoint(idJob);
    };
    Mdg2Client.prototype.setConnection = function (connection) {
        var _this = this;
        if (this.isConnected) {
            this.logger.warn('Cannot modify an open connection. Disconnect first, before trying to set the connection.');
        }
        else {
            this.connection = connection;
            this.connection.onCleanupRequests = this.requestModule.clearPendingRequests.bind(this.requestModule);
            this.connection.onCleanupSubscriptions = this.subscriptionModule.clearPendingSubscriptions.bind(this.subscriptionModule);
            this.connection.onClearPendingSubscription = function (jobId) { return _this.subscriptionModule.clearPendingSubscription(jobId); };
            this.connection.shouldRestartSubscriptions = this.shouldRestartSubscriptions;
            this.connection.restartSubscriptions = this.subscriptionModule.restartSubscriptions.bind(this.subscriptionModule);
        }
    };
    Mdg2Client.prototype.getConnection = function () {
        return this.connection;
    };
    Mdg2Client.prototype.setConnectionFromFetchConfiguration = function (input, init) {
        var _this = this;
        return fetchConnectionConfiguration(input, init)
            .then(function (_a) {
            var config = _a[0], response = _a[1];
            _this.setConnection(Mdg2Client.createConnection(__assign(__assign({}, config), { logger: _this.logger, loglevel: _this.logger.getLevel() })));
            return response;
        });
    };
    Mdg2Client.createConnection = function (config) {
        return createConnection(config);
    };
    Mdg2Client.prototype.setLogger = function (logger) {
        this.logger = logger;
        this.requestModule.setLogger(logger);
        this.subscriptionModule.setLogger(logger);
    };
    Mdg2Client.prototype.getLogger = function () {
        return this.logger;
    };
    Object.defineProperty(Mdg2Client.prototype, "isConnected", {
        get: function () {
            return this.connection && this.connection.isAuthenticated();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Mdg2Client.prototype, "isConnecting", {
        get: function () {
            return this.connection && this.connection.isInitialized();
        },
        enumerable: false,
        configurable: true
    });
    return Mdg2Client;
}());
export { Mdg2Client };
//# sourceMappingURL=Mdg2Client.js.map